import React from 'react';

import config from 'config';

import { loginButtonPropsType } from './types';

const LoginButton = ({ onClick, children, className, dataLocator }: loginButtonPropsType) => (
    <a
        href={config.CABINET_URL}
        className={className}
        data-locator={dataLocator}
        onClick={onClick}
        rel="noopener noreferrer"
    >
        {children}
    </a>
);

export default LoginButton;
